import { render, staticRenderFns } from "./EditConfigModal.vue?vue&type=template&id=a2bf12d2&scoped=true"
import script from "./EditConfigModal.vue?vue&type=script&lang=ts"
export * from "./EditConfigModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2bf12d2",
  null
  
)

export default component.exports